import _ from "underscore";
import React from "react";

export default function Paragraphs({text}) {
  if (!_.isString(text)) {
    return null;
  }
  return text.split("\n").map((str, index) => <div key={index}>{str}</div>);
}
